import { Col, Row } from '@/shared/ui/Grid'

import styles from './CompanyDetails.module.scss'

export type CompanyDetailsProps = {
	title: string
	items: {
		key?: string
		value?: string
		bankName?: string
		isFullWidth?: boolean
	}[]
}

export const CompanyDetails = ({ title, items }: CompanyDetailsProps): JSX.Element => (
	<div className={styles.companyDetails}>
		<h2 className={styles.companyName}>{title}</h2>
		<dl>
			{items.map((item, index) => (
				<div className={styles.item} key={item.value ?? item.key ?? item.bankName ?? index}>
					{item.bankName ? (
						<Row>
							<Col xs={24}>
								<dt className={styles.visuallyHidden}>Банк</dt>
								<dd className={styles.bankName}>{item.bankName}</dd>
							</Col>
						</Row>
					) : (
						<Row>
							{item.isFullWidth ? (
								<Col xs={24}>
									<dt className={styles.key}>{item.key}</dt>
									<dd className={styles.value}>{item.value ?? ''}</dd>
								</Col>
							) : (
								<>
									<Col md={9} xs={24}>
										<dt className={styles.key}>{item.key}</dt>
									</Col>
									<Col md={15} xs={24}>
										<dd className={styles.value}>{item.value}</dd>
									</Col>
								</>
							)}
						</Row>
					)}
				</div>
			))}
		</dl>
	</div>
)
